import { Component } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import { RouterOutlet } from '@angular/router';
import { ScheduleDataService } from './services/schedule-data-service';
import { ScheduleComponent } from './components/schedule-component/schedule-component';




@Component({
  selector: 'app-root-time-f0001',
  standalone: true,
  imports: [RouterOutlet, HttpClientModule, ScheduleComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [  ScheduleDataService ]
})
export class AppComponent {
  title = 'test3';
  spec = "spek";
}
